import { render, staticRenderFns } from "./SampleReport.vue?vue&type=template&id=ae71ac42"
import script from "./SampleReport.vue?vue&type=script&lang=ts"
export * from "./SampleReport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports